// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XA-z","modalContent":"YA-z","header":"ZA-z","close":"_A-z"};